import { useId } from 'react';

import { Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import type { SapXep } from '../../chung/nghiep-vu/types-vet';

/**
 * Ô đổi cách sắp xếp — port `vet/ChonSapXep.tsx` native.
 *
 * ⚠️ Hai lựa chọn KHÔNG cùng hình dạng dữ liệu: `moi_nhat` là danh sách cuộn vô hạn theo con trỏ keyset, còn
 * `ton_nhat` là một BẢNG XẾP HẠNG đúng một trang. Nên khi chọn "Nhiều token nhất", nơi gọi nói ra điều đó ở chân danh
 * sách thay vì để người dùng chờ một nút "Tải thêm" không bao giờ xuất hiện.
 */
export function ChonSapXep({ giaTri, onDoi }: { giaTri: SapXep; onDoi: (moi: SapXep) => void }) {
  const { t } = useT();
  const id = useId();
  return (
    <div className="flex flex-wrap items-center gap-2 px-5 py-3">
      <label className="text-xs text-content-muted" htmlFor={id}>
        {t('nktvSuDungAi.danhSach.sapXep')}
      </label>
      <Select<SapXep>
        id={id}
        value={giaTri}
        onChange={onDoi}
        options={[
          { value: 'moi_nhat', label: t('nktvSuDungAi.danhSach.moiNhat') },
          { value: 'ton_nhat', label: t('nktvSuDungAi.danhSach.tonNhat') },
        ]}
      />
    </div>
  );
}
